import * as React from 'react';
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useSelector } from 'react-redux';
import {
  Divider,
  IconButton,
  Select,
  Typography,
  FormControl,
  InputLabel,
  FormControlLabel,
  FormLabel,
  MenuItem,
  Radio,
  RadioGroup,
  FormHelperText,
  Box,
  Stack,
  Paper,
} from '@mui/material';
import { fullCopy, isValidDate, printVariable, download, uuidv4 } from '@util/helper';
import WebService from '@util/webService';
import useSnackbar from '@hooks/useSnackbar';
import useIndicator from '@hooks/useIndicator';
import axios from 'axios';
import { Fragment } from 'react';
import moment from 'moment';
import { Grid } from "@mui/material/";
import useDelegate from "@hooks/useDelegate";
import { styled } from "@mui/material/styles";
import ConfirmDialog from "@components/ConfirmDialog";

import CircularProgress from "@mui/material/CircularProgress";
import loading from '@images/loading.gif'

// date
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import 'dayjs/locale/ko';
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import CloseIcon from '@mui/icons-material/Close';
import { attempt } from 'lodash';
import useAlert from "@hooks/useAlert";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import {billiard} from '@util/string'
import { useTheme } from '@mui/material/styles';

import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensors,
  MeasuringStrategy
} from '@dnd-kit/core';
import {
  arrayMove,
  SortableContext,
  useSortable,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';

import { CSS } from '@dnd-kit/utilities';
import { json } from 'react-router-dom';
import { fireEvent } from '@testing-library/react';
import { AlarmAdd } from '@mui/icons-material';

const SortableItem = ({ id, children }) => {
  const {
    setNodeRef,
    attributes,
    listeners,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  return (
    <Paper
      ref={setNodeRef}
      sx={{
        transform: CSS.Transform.toString(transform),
        transition: transition,
        p: 2,
      }}
    >
      {/* 드래그 핸들 */}
      <Box
        {...attributes}
        {...listeners}
        sx={{
          cursor: 'grab',
          mb: 1,
          // color: 'text.secondary',
        }}
      >
        <Typography variant='body2' sx={{ mb: 2 }}>
          ⠿ 끌어서 순서이동
        </Typography>

      </Box>

      {/* 실제 내용 */}
      {children}
    </Paper>
  );
}

const ManagerSurveyPartMod = ({ record, dialogHandler, callback }) => {
  const [openSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  // const [activeRow, set_activeRow] = useState({...record})
  // redux
  const codes = useSelector(state => state.codeReducer);
  const questCodes = codes.filter(r => r.codeGroupId === 'SA31')
  const modeCodes = codes.filter(r => r.codeGroupId === 'SA33')
  const account = useSelector(state => state.accountReducer);
  const schola = useSelector(state => state.scholaReducer);
  const dateFormat = 'YYYY-MM-DD HH:mm:ss';
  const { alert, renderAlert } = useAlert()
  const [quests, set_quests] = useState([])
  const [dirtyFields, set_dirtyFields] = useState({})
  const inputRefs = React.useRef({})
  const [smsts, set_smsts] = useState([])
  const theme = useTheme() 
  const [alarm, set_alarm] = useState({
    msg: '',
    elKey: ''
  })
  const scrollPos = useRef(0)
  const scrollContainerRef = useRef(null)
  const handleClose = async (event, reason) => {
    if (reason && reason === "backdropClick") {
      return
    } 
    else {
      dialogHandler[1](false)
      if (callback) {
        callback()
      }
    }
  }

  const fixError = (key) => {
    const prevError = dirtyFields[key]
    if (prevError) {
      set_dirtyFields({ ...dirtyFields, [key]: '' })
    }

  }

  const setInputRef = (el, key) => {
    if (el) inputRefs.current[key] = el;
    else delete inputRefs.current[key]; // unmount 시 정리
  }

  const handleFormChange = (e) => {
  }

  const fetchSmsts = async() => {
    const url = `/smst/${schola.id}`
    openIndicator()
    const resp = await WebService.get(url, {
        pageNum:0,
        pageSize:10, 
    })
    closeIndicator()
    if(resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    const records = JSON.parse(repMessage.records)
    
    set_smsts(records)
  }

  const fetchQuests = async () => {
    if (record.id === -1) {
      return
    }

    const url = `/survey/${record.id}`
    openIndicator()
    const resp = await WebService.get(url, {
      useYn: 'Y'
    })
    closeIndicator()
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }

    const repMessage = JSON.parse(resp.repMessage)
    const records = JSON.parse(repMessage.records)
    if (records.length >= 0) {
      const quests = records[0].quests
      for (let quest of quests) {
        quest.startTime1 = quest.startTime
        quest.startTime2 = moment(quest.startTime, dateFormat).format('HH:mm:ss')

        quest.endTime1 = quest.endtime
        quest.endTime2 = moment(quest.endtime, dateFormat).format('HH:mm:ss')
      }
      console.log('quests=>', quests)
      for (const quest of quests) {
        quest.key = uuidv4()
        for (const ans of quest.anss) {
          ans.key = uuidv4()
        }
      }
      set_quests(quests)
    }
  }

  const onLoad = async () => {
    await fetchQuests()
    await fetchSmsts()
  }

  const validate = async (name, value) => {
  }

  const onSubmit = async () => {

    const row = { ...activeRow }
    const startTime = moment(row.startTime1, dateFormat).format('YYYY-MM-DD') + ' ' + moment(row.startTime2, "HH:mm:ss").format('HH:mm:00')
    const endTime = moment(row.endTime1, dateFormat).format('YYYY-MM-DD') + ' ' + moment(row.endTime2, "HH:mm:ss").format('HH:mm:00')
    row.startTime = startTime
    row.endTime = endTime


    // sqNum 최종 셋팅
    for (const [idx, quest] of quests.entries()) {
      quest.sqNum = idx + 1
    }

    // anss의 sqNum은 서버에서 셋팅
    const url = `/survey/school/${schola.id}`
    const data = {
      survey: row,
      quests: quests
    }

    console.log('data=>', data)
    openIndicator()
    const resp = await WebService.post(url, data)
    closeIndicator()

    console.log('resp=>', resp)
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }

    const repMessage = JSON.parse(resp.repMessage)
    const record = JSON.parse(repMessage.record)
    await handleChange({ target: { name: 'id', value: record.id } })
    updateState()

    console.log('fin...........................')
    openSnackbar('저장되었습니다.')

  }


  const validate2 = async () => {
    // inputRefs.current[quests[0].key].focus()
    // return
    let firstQuestErrorKey = null
    let firstAnsErrorKey = null
    const newAlaram = {
      msg: '',
      elKey: ''
    }
    // set_dirtyFields({})
    Object.keys(dirtyFields).forEach((key) => {
      delete dirtyFields[key];
    });


    set_alarm(newAlaram)


    const emsg = '값이 비어 있습니다.'
    if (!activeRow.title) {
      dirtyFields.title = emsg
    }
    if (!activeRow.startTime1) {
      dirtyFields.startTime1 = emsg
    }

    if (!activeRow.endTime1) {
      dirtyFields.endTime1 = emsg
    }

    if (activeRow.modeCode === 'M001' && activeRow.smstId === -1) {
      dirtyFields.smstId = '강좌 설문조사를 할 기수를 선택해 주세요.'
    }

    for (const quest of quests) {
      if (!quest.txt) {
        dirtyFields[quest.key] = emsg
        if (!firstQuestErrorKey) {
          firstQuestErrorKey = quest.key
        }
      }
      for (const ans of quest.anss) {
        if (!ans.txt) {
          dirtyFields[ans.key] = emsg
          if (!firstAnsErrorKey) {
            firstAnsErrorKey = ans.key
          }
        }
      }
    }

    const shortQuests = quests.filter(r => (r.questCode === 'Q000' || r.questCode === 'Q001') && r.anss.length < 2)

    set_dirtyFields({ ...dirtyFields })


    // 개별적 알럿
    if (!activeRow.title) {
      newAlaram.msg = '제목이 비어 있습니다.'
      newAlaram.elKey = 'title'
    }
    else if (!activeRow.startTime1) {
      newAlaram.msg = '설문조사 시작일이 비어 있습니다.'
      newAlaram.elKey = 'startTime1'
      // alert('설문조사 시작일이 비어 있습니다.')
      // inputRefs.current.startTime1?.focus()
      return
    }
    else if (!moment(activeRow.startTime1, dateFormat, true).isValid()) {
      newAlaram.msg = '설문조사 시작일이 유효하지 않습니다.'
      newAlaram.elKey = 'startTime1'
      // alert('설문조사 시작일이 유효하지 않습니다.')
      // inputRefs.current.startTime1?.focus()
      return
    }


    else if (!activeRow.endTime1) {
      newAlaram.msg = '설문조사 종료일이 비어 있습니다.'
      newAlaram.elKey = 'endTime1'
      // alert('설문조사 종료일이 비어 있습니다.')
      // inputRefs.current.endTime1?.focus()
      // return
    }

    else if (!moment(activeRow.endTime1, dateFormat, true).isValid()) {
      newAlaram.msg = '설문조사 종료일이 유효하지 않습니다.'
      newAlaram.elKey = 'endTime2'
      // alert('설문조사 종료일이 유효하지 않습니다.')
      // inputRefs.current.startTime1?.focus()
      // return
    }

    else if (
      moment(activeRow.startTime1, dateFormat, true)
        .isAfter(moment(activeRow.endTime1, dateFormat, true))
    ) {
      newAlaram.msg = '설문조사 시작일은 종료일 이후일 수 없습니다.'
      newAlaram.elKey = 'startTime1'
      // alert('설문조사 시작일은 종료일 이후일 수 없습니다.')
      // inputRefs.current.startTime1?.focus()
      // return
    }

    else if (quests.length == 0) {
      newAlaram.msg = '한 개 이상의 질문이 필요합니다.'
      // return
    }

    else if (firstQuestErrorKey) {
      newAlaram.msg = '질문이 비어 있습니다.'
      newAlaram.elKey = firstQuestErrorKey
      // alert('질문이 비어 있습니다.')
      // inputRefs.current[firstQuestErrorKey]?.focus()   
      // return 
    }

    else if (firstAnsErrorKey) {
      newAlaram.msg = '선택지가 비어 있습니다.'
      newAlaram.elKey = firstAnsErrorKey
      // alert('선택지가 비어 있습니다.')
      // inputRefs.current[firstAnsErrorKey]?.focus()
      // return
    }


    else if (shortQuests.length > 0) {
      const quest = shortQuests[0]
      newAlaram.msg = '단일응답 또는 복수응답일 경우 2개 이상의 선택지가 필요합니다.'
      newAlaram.elKey = quest.key
      // alert('단일응답 또는 복수응답일 경우 2개 이상의 선택지가 필요합니다.')
      // inputRefs.current[quest.key]?.focus()
      // return
    }

    else if (Object.keys(dirtyFields).length > 0) {
      newAlaram.msg = '화면의 에러를 확인해 주세요.'
      // alert('화면의 에러를 확인해 주세요.')
      // return
    }

    setTimeout(() => {
      set_alarm({ ...newAlaram })
    }, 500)

    if (newAlaram.msg === '') {
      return true
    }
    else {
      return false
    }
  }

  const { activeRow, errors, updateState, handleChange, handleSubmit, factor } = useDelegate({
    initialValues: { ...record },
    onSubmit: onSubmit,
    validate: validate,
  });


  const catCodeList = codes.filter(r => r.codeGroupId === 'SA24')

  const FormHelperTexts = styled(FormHelperText)`
    width: 100%;
    padding-left: 16px;
    font-weight: 700 !important;
    color: #d32f2f !important;
  `;


  const handleDragStart = () => {
    // if (scrollContainerRef.current) {
    //     scrollPos.current = scrollContainerRef.current.scrollTop;
    //     console.log("Drag Start - Stored container scroll pos:", scrollPos.current);
    // }
  }

  const handleDragEnd = (event) => {
    const { active, over } = event
    if (!over || active.id === over.id) return
    scrollPos.current = scrollContainerRef.current.scrollTop;
    set_quests((items) => {
      const oldIndex = items.findIndex(i => i.key === active.id)
      const newIndex = items.findIndex(i => i.key === over.id)
      return arrayMove(
        items,
        oldIndex,
        newIndex
      )
        .map((item, idx) => (
          {
            ...item,
            sqNum: idx + 1
          }
        ))
    });
    setTimeout(() => {
      if (scrollContainerRef.current) {
        console.log("Drag End - Restoring scroll pos:", scrollPos.current);
        scrollContainerRef.current.scrollTo({ top: scrollPos.current, behavior: 'auto' });
      }
    }, 0);

  }

  const onNewQuest = () => {
    const now = moment().format(dateFormat)
    const quest = {
      id: -1,
      surveyId: activeRow.id,
      sqNum: quests ? quests.length + 1 : 1,
      txt: '',
      questCode: 'Q000',
      mustYn: 'Y',
      anss: [],
      key: uuidv4(),
      uptTime: now,
      regTime: now
    }
    quests.push(quest)
    for (let i = 0; i < 4; i++) {
      onNewAns(quests.length - 1)
    }

    set_quests([...quests])
  }


  const onNewAns = (questIdx) => {
    const ans = createAns(questIdx)
    quests[questIdx].anss.push(ans)
    set_quests([...quests])
  }

  const createAns = (questIdx) => {
    const now = moment().format(dateFormat)
    const ans = {
      id: -1,
      questId: quests[questIdx].id,
      txt: '',
      useYn: 'Y',
      key: uuidv4(),
      uptTime: now,
      regTime: now,
    }
    return ans
  }

  useEffect(() => {
    if (quests.length == 0) {
      onNewQuest()
    }
  }, []);

  useEffect(() => {
    onLoad()
  }, [])

  useEffect(() => {
    if (alarm.msg) {
      alert(alarm.msg)
      inputRefs.current[alarm.elKey]?.focus()
    }
  }, [alarm])


  return (
    <DndContext onDragStart={handleDragStart} onDragEnd={handleDragEnd}>
      
      <Box component="form" >
        {renderIndicator()}
        {renderAlert()}
        {/* <Box component="form" > */}
        <Dialog open={dialogHandler[0]} onClose={handleClose} maxWidth='md' fullWidth PaperProps={{
          sx: { p: 3 }
        }} >
          <DialogTitle>
            <Typography variant='h5' align='center'>
              설문조사
            </Typography>
            <Divider></Divider>
          </DialogTitle>
          {/* <DialogContent style={{minHeight:600, backgroundColor: '#e8eaf6'}} > */}
          <DialogContent style={{ minHeight: 600, }} ref={scrollContainerRef}>
            {/* <Stack spacing={2} sx={{ backgroundColor: '#f5f5f5', p: 2 }}>
              {[1, 2, 3].map((item, idx) => (
                <Paper key={idx} sx={{ p: 0 }} elevation={0}>
                  <Typography fontWeight={600}>질문 {idx + 1}</Typography>
                  <Typography>답 1</Typography>
                  <Typography>답 2</Typography>
                </Paper>
              ))}
            </Stack> */}

            <br />
            <Grid container spacing={1} >

              <Grid item xs={12} style={{ backgroundColor: '#fff' }}>
                <TextField
                  label={'제목'}
                  fullWidth
                  required
                  inputRef={(el) => setInputRef(el, 'title')}
                  name={'title'}
                  defaultValue={activeRow['title']}
                  onChange={e => {
                    const value = e.target.value.trim()
                    activeRow.title = value
                    if (value.length > 0) {
                      fixError('title')
                    }
                  }}
                  onBlur={handleFormChange}
                />
                <FormHelperTexts>{dirtyFields.title}</FormHelperTexts>
              </Grid>
              <Grid item xs={12} style={{ backgroundColor: '#fff' }}>
                <TextField
                  label={'설명'}
                  fullWidth
                  multiline
                  rows={4}
                  name={'content'}
                  defaultValue={activeRow['content']}
                  onChange={e => {
                    activeRow.content = e.target.value
                  }}

                />
                <FormHelperTexts>{dirtyFields.content}</FormHelperTexts>
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={1}>
                  <Grid item xs={6}>
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'ko'}>
                      <DatePicker
                        label={'설문조사 시작일'}
                        required
                        value={activeRow.startTime1}
                        defaultValue={null}
                        name={'startTime1'}
                        inputFormat="YYYY-MM-DD"
                        onChange={(newValue) => {
                          if (!newValue || !newValue.isValid()) {
                            activeRow.startTime1 = null;
                            handleChange({ target: { name: 'startTime1', value: null } });
                            updateState();
                            set_dirtyFields({ ...dirtyFields, startTime1: '값이 비어 있습니다.' })
                            return;
                          }

                          const dtime = moment(new Date(newValue))
                          const d = dtime.format(dateFormat)
                          activeRow['startTime1'] = d
                          // set_activeRow({...activeRow})
                          console.log('d===>', d)
                          handleChange({ target: { name: 'startTime1', value: d } })
                          set_dirtyFields({ ...dirtyFields, startTime1: '' })
                          updateState()
                        }}
                        renderInput={(params) =>
                          <TextField name={'startTime1'} fullWidth size="small" {...params}
                            inputRef={el => {
                              params.inputRef(el)
                              setInputRef(el, 'startTime1')
                            }}
                          />
                        }
                      />
                    </LocalizationProvider>
                    <FormHelperTexts>{dirtyFields.startTime1}</FormHelperTexts>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      disabled={true}
                      size="small"
                      required
                      label={'설문조사 시작시간'}
                      value={activeRow['startTime2']}
                      onChange={handleChange}
                      InputProps={{
                        readOnly: true,
                      }}
                      onBlur={handleFormChange}
                    />
                    <FormHelperTexts>{errors['startTime2']}</FormHelperTexts>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={1}>
                  <Grid item xs={6}>
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'ko'}>
                      <DatePicker
                        label={'설문조사 종료일'}
                        required
                        name={'endTime1'}
                        value={activeRow.endTime1}
                        inputFormat="YYYY-MM-DD"

                        onChange={(newValue) => {
                          if (!newValue || !newValue.isValid()) {
                            activeRow.endTime1 = null;
                            handleChange({ target: { name: 'endTime1', value: null } });
                            updateState();
                            set_dirtyFields({ ...dirtyFields, endTime1: '값이 비어 있습니다.' })
                            return;
                          }

                          const dtime = moment(new Date(newValue))
                          const d = dtime.format(dateFormat)
                          activeRow['endTime1'] = d
                          handleChange({ target: { name: 'endTime1', value: d } })
                          updateState()
                          set_dirtyFields({ ...dirtyFields, endTime1: '' })
                        }}
                        renderInput={(params) =>
                          <TextField name={'endTime1'} fullWidth size="small" {...params}
                            inputRef={el => {
                              params.inputRef(el)
                              setInputRef(el, 'endTime1')
                            }}

                          />
                        }
                      />
                    </LocalizationProvider>
                    <FormHelperTexts>{dirtyFields.endTime1}</FormHelperTexts>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      size="small"
                      disabled={true}
                      required
                      label={'설문조사 종료시간'}
                      value={activeRow['endTime2']}
                      onChange={handleChange}
                      onBlur={handleFormChange}
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
              {
                moment(activeRow.startTime1, dateFormat, true).isAfter(moment(activeRow.endTime1, dateFormat, true)) ? (
                  <FormHelperTexts>{'설문조사 시작일은 종료일 이후일 수 없습니다.'}</FormHelperTexts>
                ) : null
              }
              <Grid item xs={12}>
                <Typography variant='body2' color={theme.palette.secondary.main}>
                  {billiard} 설문유형을 강좌 설문조사로 설정할 경우 학생의 수강 정보가 보호자에게 자동 노출되므로 학생정보와 강좌명을 별도로 입력받을 필요 없습니다.
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Grid container >
                  
                  <Grid item xs={6}>
                    <FormControl>
                      <FormLabel>설문유형</FormLabel>
                      <RadioGroup
                        aria-labelledby={'modeCode'}
                        name={`modeCode`}
                        value={activeRow.modeCode}
                        row
                        onChange={e => {
                          handleChange({ target: { name: 'modeCode', value: e.target.value } })
                          if(e.target.value === 'M000') {
                            handleChange({ target: { name: 'smstId', value: -1 } })
                            fixError('smstId')
                          }
                          
                          updateState();
                        }}
                      >
                        {
                          modeCodes.map((code, idx2) => (
                            <FormControlLabel key={code.code} value={code.code} control={<Radio disableRipple disableFocusRipple />}
                              label={
                                code.name
                              }
                            />
                          ))
                        }
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Grid item xs={6}>
                    {
                      activeRow.modeCode === 'M001' ? (
                        <FormControl fullWidth >
                          <FormLabel>기수선택</FormLabel>
                          {/* <InputLabel id='topic' size='small' sx={{fontSize:'0.9em'}}>
                            년도/기수
                          </InputLabel> */}
                          <Select
                            notched={false}
                            labelId='gisu'
                            label='년도/기수'
                            size='small'
                            sx={{fontSize:'0.9em'}}
                            name={'smstId'}
                            value={activeRow.smstId}
                            onChange={(e) => {
                              handleChange({ target: { name: 'smstId', value: e.target.value } })
                              updateState()

                              if (activeRow.modeCode === 'M0000') {
                                fixError('smstId')
                              }
                              else {
                                if(activeRow.modeCode === 'M001' && activeRow.smstId > 0) {
                                  fixError('smstId')
                                }
                              }
                            }}>
    
                            <MenuItem value={-1}>
                              선택
                            </MenuItem>
                            {smsts.map((s, index) => {
                              return (
                                <MenuItem key={index} value={s.id}>
                                  {s.year}/{s.gisu}
                                </MenuItem>
                              )
                            })}
                          </Select>
                        </FormControl>
                        
                      ) : null
                    }
                    <FormHelperTexts>{dirtyFields.smstId}</FormHelperTexts>
                  </Grid>
                </Grid>
                
              </Grid>
              <Grid item xs={12}>
              {
                quests.length == 0 ? (
                  <FormHelperTexts>{'한 개 이상의 질문이 필요합니다. 질문추가를 해 주세요.'}</FormHelperTexts>
                ) : null
              }
              </Grid>
              <Grid item xs={12}>
                <SortableContext items={quests.map(q => q.key)} strategy={verticalListSortingStrategy} >
                  <Stack spacing={2} sx={{ backgroundColor: '#f5f5f5', p: 2 }} >

                    {
                      quests.map((quest, idx) => (

                        <SortableItem key={quest.key} id={quest.key}>
                          <Grid container spacing={1} >
                            <Grid item xs={12} >
                              <Grid container spacing={1}>
                                <Grid item xs={11}>
                                  <TextField
                                    // style={{ backgroundColor: idx % 2 === 0 ? '#e8eaf6': '#fff'}}
                                    label={`${idx + 1}. 질문`}
                                    variant="filled"
                                    required
                                    fullWidth
                                    inputRef={(el) => setInputRef(el, quest.key)}
                                    name={quest.key}
                                    defaultValue={quest.txt}
                                    onChange={(e) => {
                                      const value = e.target.value.trim()
                                      quest.txt = value
                                      if (value.length > 0) {
                                        fixError(quest.key)
                                      }

                                    }}
                                    onBlur={handleFormChange}
                                  />
                                </Grid>
                                <Grid item xs={1}>
                                  <IconButton onClick={() => {
                                    document.activeElement?.blur()
                                    quests.splice(idx, 1)
                                    set_quests([...quests])
                                  }}>
                                    <CloseIcon />
                                  </IconButton>
                                </Grid>
                              </Grid>
                            </Grid>
                            <Grid item xs={12}>
                              <FormHelperTexts>{dirtyFields[quest.key]}</FormHelperTexts>
                            </Grid>
                            <Grid item xs={12}>
                              <FormControl>
                                <FormLabel id={'m_' + idx}>응답필수 여부</FormLabel>
                                <RadioGroup
                                  aria-labelledby={'m_' + idx}
                                  name={`m_${idx}`}
                                  value={quest.mustYn}
                                  onChange={(e) => {
                                    quest.mustYn = e.target.value;
                                    set_quests([...quests]);
                                    if (document.activeElement instanceof HTMLElement) {
                                      // 스크롤 되는 현상 빙지
                                      document.activeElement.blur();
                                    }
                                  }}
                                  row
                                >
                                  {
                                    [{ code: 'Y', name: 'Y' }, { code: 'N', name: 'N' }].map((code, idx2) => (
                                      <FormControlLabel key={code.code} value={code.code} control={<Radio disableRipple disableFocusRipple />}
                                        label={
                                          code.name
                                        }
                                      />
                                    ))
                                  }
                                </RadioGroup>
                              </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                              <FormControl>
                                <FormLabel id={'qc_' + idx}>응답유형</FormLabel>
                                <RadioGroup
                                  aria-labelledby={'qc_' + idx}
                                  name={`qc_${idx}`}
                                  value={quest.questCode}
                                  row
                                  onChange={e => {
                                    quest.questCode = e.target.value
                                    if (e.target.value === 'Q002') {
                                      quest.anss = []
                                    }
                                    set_quests([...quests])
                                    if (document.activeElement instanceof HTMLElement) {
                                      document.activeElement.blur();
                                    }
                                  }}
                                >
                                  {
                                    questCodes.map((code, idx2) => (
                                      <FormControlLabel key={code.code} value={code.code} control={<Radio disableRipple disableFocusRipple />}
                                        label={
                                          code.name
                                        }
                                      />
                                    ))
                                  }
                                </RadioGroup>
                              </FormControl>
                            </Grid>
                            {
                              quest.questCode === 'Q000' || quest.questCode === 'Q001' ? (
                                <>
                                  {
                                    quest.anss.map((ans, idx2) => (
                                      <>
                                        <Grid item xs={12}>
                                          <Grid container key={ans.key} spacing={1}>
                                            <Grid item xs={11}>
                                              <TextField
                                                label={`${idx2 + 1}. 선택지`}
                                                variant="standard"
                                                required
                                                fullWidth
                                                inputRef={(el) => setInputRef(el, ans.key)}
                                                name={ans.key}
                                                defaultValue={ans.txt}
                                                onChange={(e) => {
                                                  const value = e.target.value.trim()
                                                  ans.txt = value
                                                  if (value.length > 0) {
                                                    fixError(ans.key)
                                                  }
                                                }}
                                                onBlur={(e) => {

                                                }}
                                              />
                                            </Grid>
                                            <Grid item xs={1}>
                                              <IconButton onClick={() => {
                                                document.activeElement?.blur()
                                                quest.anss.splice(idx2, 1)
                                                set_quests([...quests])
                                              }}>
                                                <CloseIcon />
                                              </IconButton>
                                            </Grid>
                                          </Grid>
                                          <FormHelperTexts>{dirtyFields[ans.key]}</FormHelperTexts>
                                        </Grid>
                                        {/* <Grid item xs={12}>
                                          <FormHelperTexts>{dirtyFields[ans.key]}</FormHelperTexts>
                                        </Grid> */}
                                      </>

                                    ))
                                  }
                                  <Grid item xs={12}>
                                    {
                                      quest.questCode !== 'Q002' && quest.anss.length < 2 ? (
                                        <FormHelperTexts>{'2개 이상의 선택지가 필요합니다.'}</FormHelperTexts>
                                      ) : null
                                    }
                                  </Grid>
                                  <Grid item xs={12}>
                                    <Button
                                      onClick={() => {
                                        document.activeElement?.blur()
                                        onNewAns(idx)
                                      }}
                                    >
                                      응답 선택지 추가
                                    </Button>

                                  </Grid>
                                </>
                              ) : null
                            }
                          </Grid>
                        </SortableItem>



                      ))
                    }
                  </Stack>
                </SortableContext>

              </Grid>

            </Grid>

          </DialogContent>
          <DialogActions >
            <Grid container spacing={1}>
              <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-start', paddingLeft: 25 }}>
                <Button
                  onClick={() => {
                    document.activeElement?.blur()
                    onNewQuest()
                  }}
                  variant='contained'
                >
                  질문추가
                </Button>
              </Grid>
              <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
                <Button onClick={handleClose} style={{ marginRight: 10 }}>
                  닫기
                </Button>

                <ConfirmDialog
                  btn={
                    <Button variant='contained' disabled={false}
                      onMouseOver={() => {
                        document.activeElement?.blur();
                      }}
                    >
                      저장
                    </Button>
                  }
                  title={'저장'}
                  content={'내용을 저장하시겠습니까?'}
                  bc={'primary'}
                  preHandle={async () => {
                    return validate2()
                  }}
                  perform={() => {
                    // console.log('quests=>', quests)
                    onSubmit()
                  }}
                />
              </Grid>
            </Grid>

          </DialogActions>
        </Dialog>

      </Box>
    </DndContext>

  )
}

export default ManagerSurveyPartMod
